module.exports = __webpack_public_path__ + "img/wpr.6a5f89bc.svg";